module.exports = __webpack_public_path__ + "img/arrow-down-white.ee5b2a75.svg";